import { createSelector } from 'reselect';
import { getNamespace } from './Home.schema';

const getProps = (state, props) => props;

const getDays = (state, { archived }) => state.home[getNamespace(archived)].daysOrder;


export const getArchivedCount = (state) => state.home.archivedCount;
export const getArchivedCountLoaded = (state) => state.home.archivedCountLoaded;
export const getDaysOrder = createSelector([getDays, getProps],
    (daysOrder, { year }) => daysOrder.filter((day) => day.indexOf(year) !== -1));
export const getYears = (state, { archived }) => state.home[getNamespace(archived)].years;
export const getApplicationsLoaded = (state, { archived }) => state.home[getNamespace(archived)].loaded;

export const getApplications = (state, { archived }) => state.home[getNamespace(archived)].applications;
export const getApplication = createSelector(
    [getApplications, getProps],
    (applications, { applicationId }) => {
        const application = applications.find((a) => a.applicationId === applicationId);
        if (applications.length && !application) {
            return null;
        }
        return application;
    }
);

export const getApplicationsByDate = (state, { date, archived }) => {
    const namespace = getNamespace(archived);
    return state.home[namespace].days[date];
};
export const getApplicationFile = (state, { key }) => {
    const [applicationId, fileId] = key.split('_');
    return (state.home.applicationFiles[applicationId] ? state.home.applicationFiles[applicationId][fileId] : null);
};
export const getEditUrl = (state, { key, archived }) => (state.home[getNamespace(archived)].editUrls[key] ? state.home[getNamespace(archived)].editUrls[key] : null);

export const getScrollPosition = (state, { archived }) => state.home[getNamespace(archived)].scrollPosition;
export const getNestedAnswer = (questionName) => createSelector(
    [getApplication],
    (application) => application[questionName][questionName]
);
export const getAnswer = (questionName) => createSelector(
    [getApplication],
    (application) => application[questionName]
);


export const getApplicationByDateSorted = createSelector(
    [getApplications, getApplicationsByDate],
    (applications, applicationIdsByDate) => applicationIdsByDate.sort((a, b) => {
        const applicationA = applications.find((app) => app.applicationId === a);
        const applicationB = applications.find((app) => app.applicationId === b);
        const dateA = new Date(applicationA.applicationDate);
        const dateB = new Date(applicationB.applicationDate);
        return dateB - dateA;
    })
);
export const getAllApplicationFiles = (state, { applicationId }) => [...getAnswer('cvFiles')(state, { applicationId }), ...getAnswer('customFiles')(state, { applicationId })];
export const getAllApplicationFilesMapped = createSelector([getAllApplicationFiles],
    (files) => files.filter((f) => Boolean(f.name)).map((f) => { return { name: f.name, fileId: f.fileId } }));

export const getApplicationFileCount = createSelector([getAllApplicationFiles],
    (files) => files.filter((f) => Boolean(f.name)).length);
